import { SignUp } from "@clerk/clerk-react";
import { useSearchParams } from "react-router-dom";
import { COLORS } from "../hooks/useAudioRecorder";
import { handinvoiceClerkAppearance } from "../utils/clerkAppearance";
import AppFooter from "../components/AppFooter";

export default function SignUpPage() {
  const [params] = useSearchParams();
  const redirectUrl = params.get("redirect_url") || "/";
  return (
    <div
      data-testid="sign-up-page"
      style={{
        position: "relative",
        minHeight: "100dvh",
        backgroundColor: COLORS.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 18px 56px",
      }}
    >
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl="/sign-in"
        forceRedirectUrl={redirectUrl}
        fallbackRedirectUrl={redirectUrl}
        appearance={handinvoiceClerkAppearance}
      />
      <AppFooter position="absolute" />
    </div>
  );
}
